class InfiniteScroll {
  static collectionDiv = "#mh-collection";
  static nextPagination = ".pagination__next";

  static init() {
    if (
      $(InfiniteScroll.collectionDiv).length &&
      $(InfiniteScroll.nextPagination).length
    ) {
      $(InfiniteScroll.collectionDiv).infiniteScroll({
        // options
        path: InfiniteScroll.nextPagination,
        scrollThreshold: 600,
        //   append: ".mh-collection-products",
        history: false,
        hideNav: ".pagination",
        status: ".page-load-status",
      });

      // Debounced event handler for load.infiniteScroll event
      const debouncedLoadHandler = bounce(() => {
        LoadMore.loadMore();
      }, 200); // Adjust debounce delay as needed

      // Attach debounced event handler to the load.infiniteScroll event
      $(InfiniteScroll.collectionDiv).on(
        "load.infiniteScroll",
        debouncedLoadHandler
      );
    }
  }
  static unload() {
    const infiniteScrollElement = window.jQuery(InfiniteScroll.collectionDiv);

    if (infiniteScrollElement.data("infiniteScroll")) {
      infiniteScrollElement.infiniteScroll("destroy");
    }
  }
  static reinit() {
    this.unload();
    this.init();
  }
}
class LoadMore {
  static loadMoreButton = "#mh-collection-load-more";

  static init() {
    $(LoadMore.loadMoreButton).on("click", (e) => {
      e.preventDefault();
      this.loadMore();
    });
  }
  static loadMore() {
    const pathname = $(".pagination__next").attr("href");
    const url = new URL(pathname, window.location.origin);
    const searchParams = url.searchParams.toString();
    // console.log({ pathname, url, searchParams });
    $(LoadMore.loadMoreButton).text("Loading More...");
    $(LoadMore.loadMoreButton).attr("disabled", true);
    Collections.fetchData(url.href, searchParams, true);
  }
  static unload() {
    $(LoadMore.loadMoreButton).attr("disabled", false);
    $(LoadMore.loadMoreButton).off("click");
  }
  static reinit() {
    this.unload();
    this.init();
  }
}
window.CollectionSidebar = class Sidebar {
  static init() {
    const sidebar = $(".sidebar-filters__heading");
    sidebar.off("click");
    sidebar.on("click", function (e) {
      e.preventDefault();
      // e.stopPropagation();
      $(this).closest(".sidebar-filters__section").toggleClass("open");
    });
  }
};
window.Collections = class Collections {
  static renderHTML(html) {
    const dom = new DOMParser().parseFromString(html, "text/html");
    document.querySelector("#mh-collection").innerHTML =
      dom.getElementById("mh-collection").innerHTML;

    // update the product count

    // document.getElementById("total-filter-product").innerHTML =
    //   dom.getElementById("count-filter-product").innerHTML;
  }
  static renderLoadMoreHTML(html) {
    const dom = new DOMParser().parseFromString(html, "text/html");
    const products = dom.querySelectorAll(
      ".render-products .collection-product"
    );
    // Select the parent element where you want to append the children
    const parentElement = document.querySelector(".render-products");
    // Iterate over each element in the NodeList and append a clone to the parent element
    products.forEach((product) =>
      parentElement.appendChild(product.cloneNode(true))
    );

    const pagination = dom.querySelector(".mh-collections-pagination");
    document.querySelector(".mh-collections-pagination").innerHTML =
      pagination.innerHTML;
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static toQueryString(obj, handleSortBy) {
    const params = new URLSearchParams();
    for (const key in obj) {
      if (Array.isArray(obj[key])) {
        obj[key].forEach((value) => {
          params.append(key, value);
        });
      } else {
        params.append(key, obj[key]);
      }
    }
    params.append("sort_by", handleSortBy);
    return params.toString();
  }

  static fetchData(url, searchParams = {}, loadMore = false) {
    if (!loadMore) {
      $("div#collection-products-container").addClass("loading");
    }
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        if (loadMore) {
          this.renderLoadMoreHTML(responseText);
          $("#mh-collection-load-more").text("Load More");
        } else {
          this.renderHTML(responseText);
        }
        if (typeof window.theme === "object") {
          window.theme.quickview.reinit();
        }
        this.updateURLHash(searchParams);
      })
      .then(() => {
        $("div#collection-products-container").removeClass("loading");
        if (loadMore) {
          bounce(() => {
            Collections.reinit();
          }, 200); // Adjust debounce delay as needed
        } else {
          // debounce does not work some case
          Collections.reinit();
        }
      })
      .catch((error) => console.error(error));
  }

  static init() {
    InfiniteScroll.init();
    LoadMore.init();
    window.CollectionSidebar.init();
  }
  static reinit() {
    window.theme.collectionGallery.reinit();
    window.CollectionSidebar.init();
    InfiniteScroll.reinit();
    LoadMore.reinit();
  }
};

// Helper function to extract page number from the path
function getPageNumberFromPath(path) {
  const match = path.match(/page=(\d+)/);
  return match ? parseInt(match[1], 10) : null;
}

// Handle back/forward navigation
window.addEventListener("popstate", function (event) {
  const urlParams = new URLSearchParams(window.location.search);
  const currentPage = urlParams.get("page") || 1;

  // Scroll to the corresponding page in the infinite scroll
  scrollToPage(currentPage);
});

// Helper function to scroll to a specific page
function scrollToPage(pageNumber) {
  const collectionDiv = document.querySelector(InfiniteScroll.collectionDiv);
  if (!collectionDiv) return;

  // Implement logic to programmatically scroll to the desired page
  console.log(`Scrolling to page ${pageNumber}`);

  // Example: Trigger infinite scroll to load the required page
  $(InfiniteScroll.collectionDiv).infiniteScroll("loadOrAppend", pageNumber);
}

// Intercept link clicks (optional)
$(document).on("click", "a[data-current_page]", function (event) {
  const currentPage = $(this).data("current_page");
  // Update the URL before navigation
  Collections.updateURLHash(`page=${currentPage}`);
});

$(function () {
  Collections.init();
});
